export default __webpack_public_path__ + "static/media/0047.5f6c6e88.jpg";